// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4f300754","313":"e7bf3577","322":"12e76364","326":"3dd97265","422":"30caeedb","558":"8dc87aa7","654":"99098348","671":"267c913d","837":"80bc3d2e"}[chunkId] + ".chunk.js";
};